import { useQuery, type UseQueryReturnType } from '@tanstack/vue-query';
import axiosInstance from '@/plugins/axios';
import type { IBEHealthCheckResponse } from '@/types/services/api.service';
import type { DefaultError } from '@tanstack/query-core';

/**
 * Composable to be used for generic api calls. Like health check etc
 */
const useApiService = () => {
  /**
   * Health check api call. This can also be used to refresh the xsrf token
   */
  const healthCheck = (): UseQueryReturnType<IBEHealthCheckResponse, DefaultError> =>
    useQuery({
      queryKey: ['healthCheck'],
      queryFn: async ({ signal }) => {
        const res = await axiosInstance.get<IBEHealthCheckResponse>(`/`, {
          signal
        });
        return res.data;
      }
    });

  return { healthCheck };
};

export default useApiService;
